// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Dropdown Component */
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host {
  display: block;
}
:host .ids-dropdown {
  display: inline-block;
  max-width: 100%;
}

ids-trigger-field[readonly-background]:not([disabled])::part(input) {
  cursor: var(--ids-cursor-pointer);
}

.ids-dropdown {
  display: block;
  position: relative;
}
.ids-dropdown ids-trigger-field[size=full] {
  display: block;
}
.ids-dropdown.full {
  display: block;
}
.ids-dropdown.full ids-trigger-field,
.ids-dropdown.full .ids-trigger-field {
  display: block;
}

.trigger-icon {
  color: var(--ids-dropdown-color-icon);
  margin: 0 0 0 var(--ids-dropdown-space-text);
  position: relative;
  top: 0;
}

:host([mode=light]) .typeahead.is-open ids-trigger-field::part(field-container) {
  background-color: var(--ids-dropdown-typeahead-color-background);
}

:host([dir=rtl]) .trigger-icon {
  margin: 0 var(--ids-dropdown-space-text) 0 0;
}

::slotted(.sub-group) {
  border-top: 1px solid var(--ids-dropdown-separator-color-border);
  padding-top: var(--ids-dropdown-separator-padding);
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(field-container) {
  margin: 0;
  border-radius: 0;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(label),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(label) {
  display: none;
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(container) {
  margin: -1px;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container) {
  box-shadow: none !important;
}
.ids-dropdown.color-variant-borderless.is-open .ids-trigger-field-slot-trigger-end {
  margin-block-start: 2px;
}
.ids-dropdown.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 17px;
  height: 50px;
}
.ids-dropdown.color-variant-borderless.field-height-lg.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 1px;
}
.ids-dropdown.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 13px;
  height: 40px;
}
.ids-dropdown.color-variant-borderless.field-height-md.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 10px;
}
.ids-dropdown.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 9px;
  height: 35px;
}
.ids-dropdown.color-variant-borderless.field-height-sm.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 5px;
}
.ids-dropdown.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 5px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -2px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs ids-trigger-field::part(input) {
  padding-inline: 3px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  margin-block-start: -2px;
}

.ids-dropdown.color-variant-in-cell ids-trigger-field::part(container) {
  margin: 1px 0;
}

.ids-dropdown.color-variant-module-nav {
  color: var(--ids-module-nav-search-input-text-color);
  display: block;
  margin-block-end: 0;
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box-option) {
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(field-container) {
  background-color: var(--ids-module-nav-input-bg-color);
  border-radius: var(--ids-module-nav-common-border-radius);
  border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);
  box-shadow: none;
  color: inherit;
  overflow: hidden;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:hover::part(field-container) {
  background-color: var(--ids-module-nav-input-hover-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:active::part(field-container) {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  border-color: var(--ids-module-nav-item-selected-text-color);
  color: var(--ids-module-nav-item-selected-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:focus-within::part(field-container) {
  background-color: var(--ids-module-nav-input-focus-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input) {
  background-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(trigger-button) {
  background-color: var(--ids-color-transparent);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input::placeholder) {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input:active) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ids-dropdown-list::part(dropdown-list) {
  max-width: var(--ids-module-nav-expanded-size);
  width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));
}
.ids-dropdown.color-variant-module-nav ids-list-box-option {
  min-height: var(--ids-module-nav-item-height);
}
.ids-dropdown.color-variant-module-nav .fieldset {
  display: contents;
}
.ids-dropdown.color-variant-module-nav .ids-input-field {
  padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);
}

:host ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=xs]) ids-dropdown-list {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) ids-dropdown-list {
  max-width: var(--ids-input-width-20);
}

:host([size=mm]) ids-dropdown-list {
  max-width: var(--ids-input-width-30);
}

:host([size=md]) ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=lg]) ids-dropdown-list {
  max-width: var(--ids-input-width-50);
}

:host([size=full]) ids-dropdown-list {
  max-width: var(--ids-input-width-full);
}

:host ids-dropdown-list,
:host([size=full]) {
  width: var(--ids-input-width-full);
}

:host([list]:not([disabled])) {
  cursor: var(--ids-cursor-pointer);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-dropdown/ids-dropdown.scss","webpack://./src/themes/mixins/ids-validation-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;ECQE,mCAAA;EACA,kCAAA;EDNA,aAAA;EACA,+EAAA;EACA,gCAAA;EACA,sCAAA;ADAF;ACEE;EACE,oCAAA;ADAJ;ACGE;EACE,2CAAA;ADDJ;ACIE;EACE,uCAAA;ADFJ;ACKE;EACE,uCAAA;ADHJ;ACKI;EACE,iCAAA;ADHN;ACOE;EACE,uCAAA;ADLJ;ACOI;EACE,iCAAA;ADLN;ACSE;EACE,qCAAA;ADPJ;ACSI;EACE,8BAAA;ADPN;ACWE;EACE,oCAAA;ADTJ;ACWI;EACE,+BAAA;ADTN;ACaE;EACE,uCAAA;ADXJ;ACaI;EACE,gCAAA;ADXN;ACeE;EACE,aAAA;ADbJ;;AA/CA;EACE,cAAA;AAkDF;AAhDE;EACE,qBAAA;EACA,eAAA;AAkDJ;;AA9CA;EACE,iCAAA;AAiDF;;AA7CA;EACE,cAAA;EACA,kBAAA;AAgDF;AA7CI;EACE,cAAA;AA+CN;AA3CE;EACE,cAAA;AA6CJ;AA3CI;;EAEE,cAAA;AA6CN;;AAvCA;EACE,qCAAA;EACA,4CAAA;EACA,kBAAA;EACA,MAAA;AA0CF;;AAtCE;EACE,gEAAA;AAyCJ;;AArCA;EACE,4CAAA;AAwCF;;AArCA;EACE,gEAAA;EACA,kDAAA;AAwCF;;AAlCE;;EACE,SAAA;EACA,gBAAA;AAsCJ;AAnCE;;EACE,aAAA;AAsCJ;;AAhCE;EACE,YAAA;AAmCJ;AAhCE;EACE,2BAAA;AAkCJ;AA9BI;EACE,uBAAA;AAgCN;AA3BI;EACE,oBAAA;EACA,YAAA;AA6BN;AAzBM;EACE,sBAAA;AA2BR;AArBI;EACE,oBAAA;EACA,YAAA;AAuBN;AAnBM;EACE,uBAAA;AAqBR;AAfI;EACE,mBAAA;EACA,YAAA;AAiBN;AAbM;EACE,sBAAA;AAeR;AATI;EACE,mBAAA;EACA,YAAA;AAWN;AAPM;EACE,uBAAA;AASR;AAHI;EACE,mBAAA;EACA,YAAA;AAKN;AADM;EACE,uBAAA;EACA,wBAAA;AAGR;;AAKE;EACE,aAAA;AAFJ;;AAOA;EACE,oDAAA;EACA,cAAA;EACA,mBAAA;AAJF;AAME;EACE,oDAAA;AAJJ;AAOE;EACE,cAAA;AALJ;AAQE;EACE,sDAAA;EACA,yDAAA;EACA,+FAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AANJ;AASE;EACE,4DAAA;AAPJ;AAUE;EACE,8DAAA;EACA,4DAAA;EACA,qDAAA;AARJ;AAWE;EACE,4DAAA;AATJ;AAYE;EACE,8CAAA;EACA,cAAA;AAVJ;AAaE;EACE,8CAAA;AAXJ;AAcE;EACE,gEAAA;AAZJ;AAeE;EACE,oDAAA;AAbJ;AAgBE;EACE,8CAAA;EACA,2JAAA;AAdJ;AAiBE;EACE,6CAAA;AAfJ;AAkBE;EACE,iBAAA;AAhBJ;AAmBE;EACE,8EAAA;AAjBJ;;AAsBA;EACE,oCAAA;AAnBF;;AAsBA;EACE,oCAAA;AAnBF;;AAsBA;EACE,oCAAA;AAnBF;;AAsBA;EACE,oCAAA;AAnBF;;AAsBA;EACE,oCAAA;AAnBF;;AAsBA;EACE,oCAAA;AAnBF;;AAsBA;EACE,sCAAA;AAnBF;;AAsBA;;EAEE,kCAAA;AAnBF;;AAuBA;EACE,iCAAA;AApBF","sourcesContent":["/* Ids Dropdown Component */\n@use '../../themes/mixins/ids-validation-mixin';\n\n:host {\n  display: block;\n\n  .ids-dropdown {\n    display: inline-block;\n    max-width: 100%;\n  }\n}\n\nids-trigger-field[readonly-background]:not([disabled])::part(input) {\n  cursor: var(--ids-cursor-pointer);\n}\n\n// Most Styles are in list-box, popup and trigger field\n.ids-dropdown {\n  display: block;\n  position: relative;\n\n  ids-trigger-field {\n    &[size='full'] {\n      display: block;\n    }\n  }\n\n  &.full {\n    display: block;\n\n    ids-trigger-field,\n    .ids-trigger-field {\n      display: block;\n    }\n  }\n}\n\n// Icon Placement\n.trigger-icon {\n  color: var(--ids-dropdown-color-icon);\n  margin: 0 0 0 var(--ids-dropdown-space-text);\n  position: relative;\n  top: 0;\n}\n\n:host([mode='light']) {\n  .typeahead.is-open ids-trigger-field::part(field-container) {\n    background-color: var(--ids-dropdown-typeahead-color-background);\n  }\n}\n\n:host([dir='rtl']) .trigger-icon {\n  margin: 0 var(--ids-dropdown-space-text) 0 0;\n}\n\n::slotted(.sub-group) {\n  border-top: 1px solid var(--ids-dropdown-separator-color-border);\n  padding-top: var(--ids-dropdown-separator-padding);\n}\n\n// Dropdown Editor\n.ids-dropdown.color-variant-borderless,\n.ids-dropdown.color-variant-in-cell {\n  ids-trigger-field::part(field-container) {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  ids-trigger-field::part(label) {\n    display: none;\n  }\n}\n\n// Dropdown Editor Borderless\n.ids-dropdown.color-variant-borderless {\n  ids-trigger-field::part(container) {\n    margin: -1px;\n  }\n\n  ids-trigger-field::part(field-container) {\n    box-shadow: none !important;\n  }\n\n  &.is-open {\n    .ids-trigger-field-slot-trigger-end {\n      margin-block-start: 2px;\n    }\n  }\n\n  &.field-height-lg {\n    ids-trigger-field::part(input) {\n      padding-inline: 17px;\n      height: 50px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 1px;\n      }\n    }\n  }\n\n  &.field-height-md {\n    ids-trigger-field::part(input) {\n      padding-inline: 13px;\n      height: 40px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 10px;\n      }\n    }\n  }\n\n  &.field-height-sm {\n    ids-trigger-field::part(input) {\n      padding-inline: 9px;\n      height: 35px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 5px;\n      }\n    }\n  }\n\n  &.field-height-xs {\n    ids-trigger-field::part(input) {\n      padding-inline: 5px;\n      height: 30px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -2px;\n      }\n    }\n  }\n\n  &.field-height-xxs {\n    ids-trigger-field::part(input) {\n      padding-inline: 3px;\n      height: 30px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -1px;\n        margin-block-start: -2px;\n      }\n    }\n  }\n}\n\n// Dropdown Editor In Cell\n.ids-dropdown.color-variant-in-cell {\n  ids-trigger-field::part(container) {\n    margin: 1px 0;\n  }\n}\n\n// Module Nav Color Variant\n.ids-dropdown.color-variant-module-nav {\n  color: var(--ids-module-nav-search-input-text-color);\n  display: block;\n  margin-block-end: 0;\n\n  ::slotted(ids-list-box) {\n    color: var(--ids-module-nav-search-input-text-color);\n  }\n\n  ::slotted(ids-list-box-option) {\n    color: inherit;\n  }\n\n  ids-trigger-field::part(field-container) {\n    background-color: var(--ids-module-nav-input-bg-color);\n    border-radius: var(--ids-module-nav-common-border-radius);\n    border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);\n    box-shadow: none;\n    color: inherit;\n    overflow: hidden;\n  }\n\n  ids-trigger-field:hover::part(field-container) {\n    background-color: var(--ids-module-nav-input-hover-bg-color);\n  }\n\n  ids-trigger-field:active::part(field-container) {\n    background-color: var(--ids-module-nav-item-selected-bg-color);\n    border-color: var(--ids-module-nav-item-selected-text-color);\n    color: var(--ids-module-nav-item-selected-text-color);\n  }\n\n  ids-trigger-field:focus-within::part(field-container) {\n    background-color: var(--ids-module-nav-input-focus-bg-color);\n  }\n\n  ids-trigger-field::part(input) {\n    background-color: var(--ids-color-transparent);\n    color: inherit;\n  }\n\n  ids-trigger-field::part(trigger-button) {\n    background-color: var(--ids-color-transparent);\n  }\n\n  ids-trigger-field::part(input::placeholder) {\n    color: var(--ids-module-nav-search-input-placeholder-text-color);\n  }\n\n  ids-trigger-field::part(input:active) {\n    color: var(--ids-module-nav-search-input-text-color);\n  }\n\n  ids-dropdown-list::part(dropdown-list) {\n    max-width: var(--ids-module-nav-expanded-size);\n    width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));\n  }\n\n  ids-list-box-option {\n    min-height: var(--ids-module-nav-item-height);\n  }\n\n  .fieldset {\n    display: contents;\n  }\n\n  .ids-input-field {\n    padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);\n  }\n}\n\n// Dropdown menu width\n:host ids-dropdown-list {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='xs']) ids-dropdown-list {\n  max-width: var(--ids-input-width-10);\n}\n\n:host([size='sm']) ids-dropdown-list {\n  max-width: var(--ids-input-width-20);\n}\n\n:host([size='mm']) ids-dropdown-list {\n  max-width: var(--ids-input-width-30);\n}\n\n:host([size='md']) ids-dropdown-list {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='lg']) ids-dropdown-list {\n  max-width: var(--ids-input-width-50);\n}\n\n:host([size='full']) ids-dropdown-list {\n  max-width: var(--ids-input-width-full);\n}\n\n:host ids-dropdown-list,\n:host([size='full']) {\n  width: var(--ids-input-width-full);\n}\n\n// Change state for external dropdown list\n:host([list]:not([disabled])) {\n  cursor: var(--ids-cursor-pointer);\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.validation-message {\n  @include mixins.antialiased();\n\n  display: flex;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  margin-top: var(--ids-space-2xs);\n  max-width: var(--ids-input-width-full);\n\n  &.has-custom-icon {\n    color: var(--ids-icon-color-default);\n  }\n\n  &.disabled {\n    color: var(--ids-input-color-text-disabled);\n  }\n\n  .ids-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  &.alert {\n    color: var(--ids-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-color-yellow-30);\n    }\n  }\n\n  &.warning {\n    color: var(--ids-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-color-orange-30);\n    }\n  }\n\n  &.error {\n    color: var(--ids-color-error-default);\n\n    &.disabled {\n      color: var(--ids-color-red-30);\n    }\n  }\n\n  &.info {\n    color: var(--ids-color-info-default);\n\n    &.disabled {\n      color: var(--ids-color-blue-30);\n    }\n  }\n\n  &.success {\n    color: var(--ids-color-success-default);\n\n    &.disabled {\n      color: var(--ids-color-green-30);\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
